import {
    PlusIcon
} from "@primer/octicons-react";
import { ActionList, ActionMenu, Box } from '@primer/react';
import {
    Column
} from 'devextreme-react/data-grid';
import Toolbar, { Item } from "devextreme-react/toolbar";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Transition } from 'semantic-ui-react';
import { SF_HACHTOAN_CONGNO_DELETE_API, SF_HACHTOAN_CONGNO_INSERT_API, SF_HACHTOAN_CONGNO_UPDATE_API } from '../../api/hachToanCongNopApi';
import { Button } from '../../components/buttons';
import { ComboboxHe } from '../../components/combobox-he';
import ComboboxKhoi from '../../components/combobox-khoi';
import { ComboboxTruong } from '../../components/combobox-truong';
import { AnimationConfirm } from '../../components/confirm';
import { DefaultDataGrid } from '../../components/data-grid';
import Text from "../../components/ui/text";
import { useCommonContext } from '../../contexts/common';
import { localStorageHelper } from '../../helpers/localStorage';
import { PageBaseStatus } from '../../models/pageBaseStatus';
import { sf_hachtoan_congno, sf_hachtoan_congno_viewmodel } from '../../models/response/hach-toan-cong-no/sf_hachtoan_congno';
import { actions } from '../../state/actions/actionsWrapper';
import { changeHachToanCongNoSelectionIds, changeHe, changeKhoi, changeTruong, closeHachToanCongNoDeleteConfirm, closeHachToanCongNoDetailModal, closeHachToanCongNoImportModal, closeHachToanCongNoRefundConfirm, deleteHachToanCongNoStart, loadHachToanCongNoStart, refundHachToanCongNoStart, saveHachToanCongNoStart, showHachToanCongNoDeleteConfirm, showHachToanCongNoDetailModal, showHachToanCongNoImportModal, showHachToanCongNoRefundConfirm } from '../../state/actions/hachToanCongNoActions';
import { RootState } from '../../state/reducers';
import { HachToanCongNoDetailModal } from './detail_modal';
import HachToanSummary from './hach-toan-summary';
import styles from "./HachToanCongNo.module.css";
import { ImportHachToanModal } from './import-modal';
const HachToanCongNoPage = () => {
    const { createUUID, checkAccesiableTo, getDataGridStorageKey } = useCommonContext();
    const dispatch = useDispatch();
    const state = useSelector((x: RootState) => x.hachToan)
    const categorySource = useSelector((x: RootState) => x.categorySource);
    const { nam_hoc } = useSelector((x: RootState) => x.common);
    const [hoanPhiTypeId, setHoanPhiTypeId] = useState<number>(-1);

    const navigate = useNavigate();
    const { status,
        //filter,
        sf_hachtoan_congno_selected_ids,
        sf_hachtoan_congno_viewmodels,
        sf_hachtoan_congno_editing,
        is_show_detail_modal,
        is_show_delete_confirm,
        is_show_import_modal,
        dm_he_id,
        dm_khoi_id,
        dm_truong_id,
        is_show_refund_confirm

    } = state;
    //const {
    //    dm_he_id, dm_khoi_id, dm_truong_id, nam_hoc
    //} = filter;

    const dataSource = useMemo(() => {
        return sf_hachtoan_congno_viewmodels.filter(x => hoanPhiTypeId == -1 || hoanPhiTypeId == x.sf_hoanphi_type_id);
    }, [hoanPhiTypeId, sf_hachtoan_congno_viewmodels])

    //useEffect(() => {
    //    dispatch(changeHachToanCongNoFilter({ ...filter, nam_hoc: param_nam_hoc }))
    //}, [param_nam_hoc])

    const grid = useRef<any>();
    const dataGridStateStorageKey = getDataGridStorageKey("hachtoan")
    const isAccessibleInsert = useMemo(() => {
        if (!checkAccesiableTo(SF_HACHTOAN_CONGNO_INSERT_API, 'POST')) return false;
        if (sf_hachtoan_congno_selected_ids.length > 0) return false;
        return true;
    }, [checkAccesiableTo, sf_hachtoan_congno_selected_ids]);


    const isAccessibleUpdate = useMemo(() => {
        if (!checkAccesiableTo(SF_HACHTOAN_CONGNO_UPDATE_API, 'PUT')) return false;
        return true;
    }, [checkAccesiableTo]);

    const isAccessibleDelete = useMemo(() => {
        if (!checkAccesiableTo(SF_HACHTOAN_CONGNO_DELETE_API, 'DELETE')) return false;
        if (sf_hachtoan_congno_selected_ids.length <= 0) return false;
        return true;
    }, [checkAccesiableTo, sf_hachtoan_congno_selected_ids]);
    const isAccessibleRefund = useMemo(() => {
        if (sf_hachtoan_congno_selected_ids.length <= 0) return false;
        return true;
    }, [checkAccesiableTo, sf_hachtoan_congno_selected_ids]);
    const handleReload = () => {
        dispatch(loadHachToanCongNoStart({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        }));
        localStorageHelper.setNamHocTruongKhoiFilter({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        })
    }

    //

    useEffect(() => {
        if (status && status === PageBaseStatus.is_need_reload)
            handleReload();
    }, [status])
    useEffect(() => {
        handleReload();
    }, [dm_he_id, dm_khoi_id, dm_truong_id, nam_hoc])

    useEffect(() => {
        if (categorySource.dm_hes.length === 0) dispatch(actions.categorySource.loadHeStart())
        if (categorySource.dm_khois.length === 0) dispatch(actions.categorySource.loadKhoiStart())
        if (categorySource.dm_truongs.length === 0) dispatch(actions.categorySource.loadDmTruongStart())
        if (categorySource.dm_namhocs.length === 0) dispatch(actions.categorySource.loadNamHocStart())

    }, [])

    const handleRefresh = () => {
        localStorage.removeItem(dataGridStateStorageKey)
        handleReload();
        grid.current.instance.state(null);
        onSelectionChanged([])
    }

    const handleCloseDeleteConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoDeleteConfirm())
    }, [])
    const handleCloseRefundConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoRefundConfirm())
    }, [])
    const handleShowDeleteConfirm = useCallback(() => {
        dispatch(showHachToanCongNoDeleteConfirm())
    }, [])
    const handleShowRefundConfirm = useCallback(() => {
        dispatch(showHachToanCongNoRefundConfirm())
    }, [])
    const handleConfirmRefund = useCallback(() => {
        dispatch(refundHachToanCongNoStart(sf_hachtoan_congno_selected_ids))
    }, [sf_hachtoan_congno_selected_ids]);

    const handleBtnInsertClick = useCallback((e: any) => {

        if (e.itemData.id === 0) {
            dispatch(showHachToanCongNoDetailModal());
        }
        if (e.itemData.id === 1) {
            dispatch(showHachToanCongNoImportModal());
        }

    }, []);
    const handleBtnEditClicked = (data: sf_hachtoan_congno_viewmodel) => {
        dispatch(showHachToanCongNoDetailModal(data));
    }
    const handleExport = useCallback(() => {
        if (grid && grid.current && grid.current.instance) {
            grid.current.instance.exportToExcel();
        }
    }, [grid])

    const onSelectionChanged = useCallback((selectedRowKeys: number[]) => {
        dispatch(changeHachToanCongNoSelectionIds(selectedRowKeys))
    }, [])
    const handleConfirmDelete = useCallback(() => {
        dispatch(deleteHachToanCongNoStart(sf_hachtoan_congno_selected_ids))
    }, [sf_hachtoan_congno_selected_ids]);

    const handleCloseDetailModal = useCallback(() => {
        dispatch(closeHachToanCongNoDetailModal())
    }, [])
    const handleSubmitDetailModal = useCallback((data: sf_hachtoan_congno) => {
        dispatch(saveHachToanCongNoStart(data))
    }, [])


    //

    const columns = useMemo((): any => {
        let result: any = [
            <Column key={createUUID()} dataField="ten_lop" caption="Tên lớp" minWidth={100} />,
            <Column key={createUUID()} dataField="ten_khoi" caption="Tên khối" minWidth={100} />,
            <Column key={createUUID()} dataField="ma_hs" caption="Mã HS" minWidth={100} />,
            <Column key={createUUID()} dataField="ho_ten" caption="Họ tên" minWidth={100} />,
            <Column key={createUUID()} dataField="noi_dung" caption="Nội dung" minWidth={200} cellRender={(cell) => {
                return (
                    <div style={{ whiteSpace: "pre-line" }}>{cell.data.noi_dung}</div>
                )
            }} />,
            <Column key={createUUID()} dataField="tong_tien" caption="Tổng tiền" minWidth={100} format={",##0"} />,
            <Column key={createUUID()} dataField="is_hoan_tra" caption="Loại" minWidth={100} cellRender={(cell) => {
                return <div>{cell.data.is_hoan_tra ? "Hoàn trả" : "Thu bổ sung"}</div>
            }} />,
            <Column key={createUUID()} dataField="is_da_thanh_toan" caption="Đã TT" minWidth={100} />,
            <Column key={createUUID()} dataField="is_hoantra_phuhuynh" caption="Hoàn trả PH" minWidth={100} />
        ];

        // Check if editing is accessible and if the payment has not been completed
        if (isAccessibleUpdate) {
            result.push(
                <Column
                    visibleIndex={1}
                    key={createUUID()}
                    width={50}
                    caption={"Sửa"}
                    alignment="center"
                    cellRender={(cell: any) => {
                        return !cell.data.is_da_thanh_toan ? (
                            <a id={`btnEdit${cell.data.id}`} style={{ cursor: "pointer", color: "#3c22ff" }}>
                                <i onClick={() => { handleBtnEditClicked(cell.data) }} className="cmd-edit-icon fas fa-edit"></i>
                            </a>
                        ) : null; // Don't render anything if already paid
                    }}
                />
            );
        }

        return result;
    }, [categorySource.dm_truongs, categorySource.dm_khois, categorySource.dm_hes, isAccessibleUpdate]);

    return (
        <React.Fragment>
            <Box className={styles.container} sx={{ p: 2 }}>

                <Transition animation="scale"
                    visible={true}
                    duration={100}
                    transitionOnMount={true}>
                    <div>
                        <div className="row">
                            <div className="col-md-12 page-toolbar">
                                <Toolbar className="bg-background">
                                    <Item location="before">
                                        <ComboboxTruong
                                            value={dm_truong_id}
                                            onValueChanged={(value) => {
                                                dispatch(changeTruong(value))
                                                //dispatch(changeHachToanCongNoFilter({
                                                //    ...filter,
                                                //    dm_truong_id: value,
                                                //    dm_khoi_id: 0,
                                                //    dm_he_id: 0
                                                //}))
                                            }}
                                        />
                                    </Item>
                                    <Item location="before">
                                        <ComboboxKhoi
                                            dm_truong_id={dm_truong_id}
                                            value={dm_khoi_id}
                                            width={150}
                                            onValueChanged={(value) => {
                                                dispatch(changeKhoi(value))
                                                //dispatch(changeHachToanCongNoFilter({
                                                //    ...filter,
                                                //    dm_khoi_id: value,
                                                //    dm_he_id: 0
                                                //}))
                                            }}
                                        />
                                    </Item>
                                    <Item location="before">
                                        <ComboboxHe
                                            dm_khoi_id={dm_khoi_id}
                                            dm_truong_id={dm_truong_id}
                                            value={dm_he_id}
                                            width={150}
                                            onValueChanged={(value) => {
                                                dispatch(changeHe(value))
                                                //dispatch(changeHachToanCongNoFilter({
                                                //    ...filter,
                                                //    dm_he_id: value
                                                //}))
                                            }}
                                        />

                                    </Item>
                                    {isAccessibleInsert &&
                                        <Item location="after"
                                            locateInMenu="never">
                                            <ActionMenu>
                                                <ActionMenu.Button style={{ height: 28 }}>
                                                    Thao tác
                                                </ActionMenu.Button>
                                                <ActionMenu.Overlay width="auto">
                                                    <ActionList showDividers>
                                                        <ActionList.Group>
                                                            <ActionList.Item
                                                                onSelect={() => { dispatch(showHachToanCongNoDetailModal()) }}
                                                            >
                                                                <ActionList.LeadingVisual >
                                                                    <PlusIcon />
                                                                </ActionList.LeadingVisual>
                                                                <Text text={`Thêm thủ công`} />
                                                            </ActionList.Item>
                                                            <ActionList.Item
                                                                onSelect={() => { dispatch(showHachToanCongNoImportModal()) }}
                                                            >
                                                                <ActionList.LeadingVisual >
                                                                    <PlusIcon />
                                                                </ActionList.LeadingVisual>
                                                                <Text text={`Import từ excel`} />
                                                            </ActionList.Item>
                                                        </ActionList.Group>

                                                    </ActionList>
                                                </ActionMenu.Overlay>
                                            </ActionMenu>
                                        </Item>
                                    }
                                    <Item location="after"
                                        locateInMenu="never">
                                        <Button
                                            type="normal"
                                            icon="fas fa-redo"
                                            text="Refresh"
                                            onClick={handleRefresh}
                                            isLoading={state.status === PageBaseStatus.is_loading}
                                        />{' '}

                                        <Button type="normal" icon="fas fa-file-excel" text="Export" onClick={handleExport} />
                                        {' '}
                                        {isAccessibleRefund &&
                                            <React.Fragment>
                                                <Button
                                                    id='btnRefund'
                                                    type="normal"
                                                    icon="fas fa-redo"
                                                    text={`Hoàn trả PH (${sf_hachtoan_congno_selected_ids.length})`}
                                                    onClick={handleShowRefundConfirm}
                                                />{' '}
                                            </React.Fragment>
                                        }
                                        {isAccessibleDelete &&
                                            <React.Fragment>
                                                <Button
                                                    id='btnDelete'
                                                    type="danger"
                                                    icon="fas fa-trash-alt"
                                                    text={`Xóa ${sf_hachtoan_congno_selected_ids.length} quyết toán`}
                                                    onClick={handleShowDeleteConfirm}
                                                />{' '}
                                            </React.Fragment>
                                        }
                                    </Item>

                                </Toolbar>
                            </div>
                            <div className="col-md-12">
                                <div className='padding-top-5'>
                                    <HachToanSummary
                                        onSelectedChanged={setHoanPhiTypeId}
                                        selectedId={hoanPhiTypeId}
                                        sf_hachtoan_congno_viewmodels={sf_hachtoan_congno_viewmodels}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className='padding-top-5'>
                                    <DefaultDataGrid
                                        gridRef={grid}
                                        columns={columns}
                                        dataSource={dataSource}
                                        keyExpr="id"
                                        height={window.innerHeight - 290}
                                        defaultPageSize={20}
                                        storageKey={dataGridStateStorageKey}
                                        isLoading={state.status == PageBaseStatus.is_loading}
                                        selection={{
                                            mode: "multiple",
                                            onSelectionChanged: (e: any) => {

                                                onSelectionChanged(e.selectedRowKeys)
                                            },
                                            selectedRowKeys: sf_hachtoan_congno_selected_ids
                                        }}
                                    />

                                </div>
                            </div>
                            {is_show_detail_modal && <HachToanCongNoDetailModal
                                sf_hachtoan_congno={sf_hachtoan_congno_editing}
                                onClose={handleCloseDetailModal}
                                onSubmit={handleSubmitDetailModal}
                                is_saving={status === PageBaseStatus.is_saving}
                                nam_hoc={nam_hoc}
                                title={`${sf_hachtoan_congno_editing ? "Sửa " : "Thêm mới "} quyết toán`}
                                animationOf={sf_hachtoan_congno_editing ? `#btnEdit${sf_hachtoan_congno_editing.id}` : "#btnInsert"}
                                dm_truong_id={dm_truong_id}
                            />
                            }
                        </div>

                    </div>
                </Transition>

                {is_show_delete_confirm &&
                    <AnimationConfirm
                        onClose={handleCloseDeleteConfirm}
                        onConfirmed={handleConfirmDelete}
                        text={`Bạn có chắc chắn muốn xóa ${sf_hachtoan_congno_selected_ids.length} khoản hạch toán đã chọn ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không xóa"
                        text_confirm_button="Tiếp tục xóa"
                        type='danger'
                        animationOf='#btnDelete'

                    />
                }
                {is_show_refund_confirm &&
                    <AnimationConfirm
                        onClose={handleCloseRefundConfirm}
                        onConfirmed={handleConfirmRefund}
                        text={`Bạn có chắc chắn muốn cập nhật ${sf_hachtoan_congno_selected_ids.length} khoản hạch toán đã chọn thành Hoàn trả PH ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không"
                        text_confirm_button="Tiếp tục"
                        type='success'
                        animationOf='#btnRefund'

                    />
                }
                {is_show_import_modal &&
                    <ImportHachToanModal
                        nam_hoc={nam_hoc}
                        animationOf="#btnInsert"
                        onClose={() => { dispatch(closeHachToanCongNoImportModal()) }}
                        onSuccess={() => {
                            dispatch(closeHachToanCongNoImportModal())
                            handleReload();
                        }}

                    />
                }
            </Box>
        </React.Fragment >
    );
}
export default HachToanCongNoPage;